// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sync-management-no-crm[data-v-5268187e]{text-align:center}.sync-management-no-crm__img[data-v-5268187e],.sync-management-no-crm__text[data-v-5268187e]{margin:0 auto}.sync-management-no-crm__text[data-v-5268187e]{max-width:765px;font-size:24px;line-height:32px}.sync-management-no-crm__link[data-v-5268187e]{color:#80cacb;font-weight:700;text-decoration:underline}.sync-management-no-crm__button[data-v-5268187e]{font-weight:700}", ""]);
// Exports
module.exports = exports;
